import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { http, setToken, getToken } from "@/lib/api";
import Mandala from "@/components/Mandala";
import { TID } from "@/constants/testIds";

const AdminLogin = () => {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  React.useEffect(() => {
    if (getToken()) nav("/admin/dashboard");
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await http.post("/admin/login", { email, password });
      setToken(data.token);
      toast.success("Welcome back.");
      nav("/admin/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden py-24">
      <div className="absolute inset-0 hero-radial opacity-70" />
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="spin-slow opacity-30">
          <Mandala size={620} />
        </div>
      </div>

      <form onSubmit={submit} className="relative z-10 glass-strong rounded-2xl p-10 w-full max-w-md">
        <div className="text-center">
          <div className="font-hindi text-lg text-[#FF9933]">प्रवेश द्वार</div>
          <h1 className="mt-1 font-display text-3xl text-white tracking-tight">Admin Sanctum</h1>
          <p className="mt-2 text-xs uppercase tracking-[0.3em] text-white/50">KASHiX Console</p>
        </div>
        <div className="mt-8 space-y-4">
          <label className="block">
            <span className="text-[10px] uppercase tracking-[0.35em] text-white/50">Email</span>
            <input
              data-testid={TID.adminEmail}
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full bg-black/60 border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-[#FF9933]"
            />
          </label>
          <label className="block">
            <span className="text-[10px] uppercase tracking-[0.35em] text-white/50">Password</span>
            <input
              data-testid={TID.adminPassword}
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 w-full bg-black/60 border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-[#FF9933]"
            />
          </label>
        </div>
        <button
          data-testid={TID.adminLoginSubmit}
          disabled={busy}
          className="mt-8 w-full inline-flex items-center justify-center rounded-full bg-[#FF9933] text-black px-6 py-3 text-xs uppercase tracking-[0.3em] font-semibold hover:bg-[#FFD700] transition-all disabled:opacity-60"
        >
          {busy ? "..." : "Enter"}
        </button>
      </form>
    </section>
  );
};

export default AdminLogin;
